/** India — WhatsApp uses country code + number without + */
export const PHONE_INDIA_DISPLAY = '+91 8106505999';
export const PHONE_INDIA_TEL = '+918106505999';
export const PHONE_INDIA_WA = '918106505999';

/** US — display as provided; `tel` uses full NANP digits. */
export const PHONE_US_DISPLAY = '+1 972-710-865';
export const PHONE_US_TEL = '+19727108655';
